export const CHART_COLORS = [
  "#78B9CB",
  "#684080",
  "#B24382",
  "#D16562",
  "#0A2240",
  "#432852",
  "#CDDB00",
  "#565656",
  "#333333",
  "#8EC2CD",
  "#68B9CB",
  "#358797",
  "#464E75",
  "#57467A",
];

export const CHART_TOOLTIP = {
  backgroundColor: "rgba(0,0,0,0.8)",
  borderColor: "rgba(255,255,255,0.1)",
  borderWidth: 1,
  padding: 10,
  textStyle: {
    color: "rgba(255,255,255,1)",
  },
};
